import {http} from "@/api/HttpClient.ts";
import {Pageable, PageModel} from "@/api/Paging.ts";
import {Backup} from "@/backup/Backup.ts";
import {BackupCreationProgressEvent, RestoreProgressEvent} from "@/backup/RestoreProgress.ts";

export async function searchBackups(pageable: Pageable): Promise<PageModel<Backup>> {
    const res = await http.get<PageModel<Backup>>(`/backups`, {params: {...pageable}});
    return res.data
}

export async function createBackup(): Promise<BackupCreationProgressEvent> {
    const res = await http.post<BackupCreationProgressEvent>(`/backups/create`);
    return res.data;
}

export async function getCreationJob(jobId: string): Promise<BackupCreationProgressEvent> {
    return (await http.get<BackupCreationProgressEvent>(`/backups/creation-jobs/${jobId}`)).data;
}
export async function getActiveCreationJob(): Promise<BackupCreationProgressEvent | null> {
    const res = await http.get<BackupCreationProgressEvent>(`/backups/creation-jobs/active`);
    return res.status === 204 ? null : res.data;
}
export async function restoreBackup(id: string): Promise<RestoreProgressEvent> {
    const res = await http.put<RestoreProgressEvent>(`/backups/${id}/restore`);
    return res.data;
}

export async function getRestoreJob(jobId: string): Promise<RestoreProgressEvent> {
    const res = await http.get<RestoreProgressEvent>(`/backups/restore-jobs/${jobId}`);
    return res.data;
}

export async function getActiveRestoreJob(): Promise<RestoreProgressEvent | null> {
    const res = await http.get<RestoreProgressEvent>(`/backups/restore-jobs/active`);
    return res.status === 204 ? null : res.data;
}

export async function deleteBackup(id: string): Promise<void> {
    await http.delete(`/backups/${id}`);
}

export async function uploadBackup(file: File): Promise<Backup> {
    const formData = new FormData();
    formData.append("file", file as Blob);
    const res = await http.post(`/backups/upload`, formData);
    return res.data;
}

export async function getBackupById(id: string): Promise<Backup> {
    const res = await http.get<Backup>(`/backups/${id}`);
    return res.data;
}
